import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { CdkDragMove, CdkDragStart } from '@angular/cdk/drag-drop';
import { leftSkuList } from '../../helper/static';
import { MatDialog } from '@angular/material/dialog';
import { MatList } from '@angular/material/list';
import { MatSelectChange } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SubscriptionLike, Observable, combineLatest } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CONFIG } from 'src/helper/app-config';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SkuInfoDialogComponent } from '../sku-info-dialog/sku-info-dialog.component';
import { ConfirmDialogModalComponent } from '../../components/confirm-dialog-modal/confirm-dialog-modal.component';
import { PlanogramService } from 'src/services/planogram.service';

@Component({
  selector: 'app-sku-new-component',
  templateUrl: './sku-new-component.component.html',
  styleUrl: './sku-new-component.component.css',
})
export class SkuNewComponentComponent implements OnInit, OnDestroy {
  @Input() planogram_id: number;
  @Input() drop_item_ids: string[] = [];
  @Input() placed_sku_list: { [key: string]: { [key: string]: [] } } = {};
  @Input() isReset: boolean = false;
  @Output() resetSkusInPlanogram = new EventEmitter();
  @ViewChild(MatList, { read: ElementRef }) child: ElementRef;
  CONFIG = CONFIG;
  left_sku_list: { [key: string]: any[] } = leftSkuList;
  // sku_filter = 'all';
  local_reset = false;
  filter_sku_list: any;
  sku_search_input: string = '';
  isAdmin: string = '0';
  review_lhs_sku_list_subscription: SubscriptionLike;
  review_screen_sku_images_subscription: SubscriptionLike;
  review_screen_sku_images_observable: Observable<any> =
    this.planogramState.review_screen_sku_images;
  review_screen_sku_images: any;
  review_lhs_sku_list_observable: Observable<any> =
    this.planogramState.review_lhs_sku_list;
  _currentIndex: number;
  _currentField: number;
  review_lhs_sku_list: any;
  search_filtered_sku_list: any;
  search_message: string = '';
  sku_images_array: any = [];
  selectedLabel: string = 'browse sku';
  assortment_table_data: any;
  constructor(
    private planogramState: PlanogramStateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private apiService: PlanogramService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      console.log('params', params);
      let planogram_id = params['planogram_id'];
      if (planogram_id) {
        setTimeout(() => {
          this.planogramState.getLhsSkuList({ planogram_id: planogram_id });
        }, 2500);
      }
    });
  }
  ngOnInit() {
    this.isAdmin = localStorage.getItem('admin_flag') || '0';
    // this.review_screen_sku_images_subscription =
    //   this.review_screen_sku_images_observable.subscribe((res) => {
    //     if (res) {
    //       this.review_screen_sku_images = res;
    //       console.log("this.review_screen_sku_images", this.review_screen_sku_images)
    //     }
    //   });
      
    // this.review_lhs_sku_list_subscription =
    //   this.review_lhs_sku_list_observable.subscribe(async (res) => {
    //     if (res && this.review_screen_sku_images) {
    //       let url = this.router.url;
    //       console.log('url========>', url);
    //       this.review_lhs_sku_list = res;
    //       this.search_filtered_sku_list = url.includes('admin-planogram')
    //         ? res['recommended']
    //         : res['all'] && res['all'].length > 0
    //         ? res['all']
    //         : res['recommended'];
    //       this.search_filtered_sku_list = this.search_filtered_sku_list.map(
    //         (v: any) => {
    //           v.loading = true;
    //           return v;
    //         }
    //       );
    //       this.assortment_table_data = res['recommended'];
    //       this.getImages(this.search_filtered_sku_list)
    //         .then((images) => {
    //           this.search_filtered_sku_list = images;
    //           this.filter_sku_list = images;
    //           console.log(
    //             'search_filtered_sku_list',
    //             this.search_filtered_sku_list
    //           );
    //         })
    //         .catch((error) => {
    //           console.error('Error processing SKU list:', error);
    //         });
    //     }
    //   });
   

    combineLatest([
      this.review_screen_sku_images_observable,
      this.review_lhs_sku_list_observable,
    ]).subscribe(
      ([reviewScreenSkuImages, reviewLhsSkuList]) => {
        if (reviewScreenSkuImages) {
          this.review_screen_sku_images = reviewScreenSkuImages;
        }
  
        if (reviewLhsSkuList && this.review_screen_sku_images) {
          let url = this.router.url;
          console.log('url========>', url);
          this.review_lhs_sku_list = reviewLhsSkuList;
          this.search_filtered_sku_list = url.includes('admin-planogram')
            ? reviewLhsSkuList['recommended']
            : reviewLhsSkuList['all'] && reviewLhsSkuList['all'].length > 0
            ? reviewLhsSkuList['all']
            : reviewLhsSkuList['recommended'];
  
          this.search_filtered_sku_list = this.search_filtered_sku_list.map(
            (v: any) => {
              v.loading = true;
              return v;
            }
          );
          this.assortment_table_data = reviewLhsSkuList['recommended'];
  
          this.getImages(this.search_filtered_sku_list)
            .then((images) => {
              this.search_filtered_sku_list = images;
              this.filter_sku_list = images;
              console.log(
                'search_filtered_sku_list',
                this.search_filtered_sku_list
              );
            })
            .catch((error) => {
              console.error('Error processing SKU list:', error);
            });
        }
      },
      (error) => {
        console.error('Error in subscriptions:', error);
      }
    );
  }

  ngOnDestroy() {
    this.resetSkusInPlanogram.emit({ reset: false });
  }

  // filterSkus = (filter: string) => {
  //   this.sku_filter = filter;
  //   this.filter_sku_list = this.review_lhs_sku_list[filter];
  //   this.search_filtered_sku_list = this.review_lhs_sku_list[filter];
  //   this.search_filtered_sku_list = this.getImages(
  //     this.review_lhs_sku_list[filter]
  //   );
  // };

  dragStart(event: CdkDragStart) {
    this._currentIndex = this.search_filtered_sku_list
      .filter((s: any) =>
        s.sku_face
          .toLowerCase()
          .includes(this.sku_search_input.trim().toLowerCase())
      )
      .indexOf(event.source.data); // Get index of dragged type
    this._currentField = this.child.nativeElement.children[this._currentIndex]; // Store HTML field
  }

  moved(_event: CdkDragMove) {
    // Check if stored HTML field is as same as current field
    if (
      this.child.nativeElement.children[this._currentIndex] !==
      this._currentField
    ) {
      if (this._currentIndex === 0) {
        this.child.nativeElement.children[
          this._currentIndex
        ].insertAdjacentElement('beforebegin', this._currentField);
      } else {
        this.child.nativeElement.children[
          this._currentIndex - 1
        ].insertAdjacentElement('afterend', this._currentField);
      }
    }
  }

  reset() {
    this.local_reset = true;
    this.resetSkusInPlanogram.emit({ reset: true });
  }

  // savePlanogram() {
  //   let isEmpty = this.checkIfEmptyPlanogram();
  //   if (isEmpty) {
  //     const dialogRef = this.dialog.open(ConfirmDialogModalComponent, {
  //       width: '500px',
  //       data: {
  //         header_msg: 'Error',
  //         header_msg_description: 'Cant create empty plano',
  //         ok_action: 'Ok',
  //       },
  //     });
  //   } else {
  //     this.planogramState.saveCustomPlanogram({
  //       id: this.planogram_id,
  //       data: { facings_data: this.placed_sku_list },
  //     });
  //     this.local_reset = false;
  //   }
  // }

  checkIfEmptyPlanogram() {
    let coolers = Object.keys(this.placed_sku_list);
    let empty = true;
    for (let i = 0; i < coolers.length; i++) {
      let facings = this.placed_sku_list[coolers[i]]['facings'];
      facings.forEach((sku: any) => {
        if (sku.final_facings !== 0) {
          empty = false;
        }
      });
    }
    return empty;
  }

  showSKUInformation(sku: any) {
    this.dialog.open(SkuInfoDialogComponent, {
      position: { right: '0', top: '0', bottom: '0' },
      height: '100%',
      width: '400px',
      data: { sku: sku },
    });
  }

  async getImages(dataArray: any) {
    if (!dataArray) return;

    for (const sku of dataArray) {
      sku.loading = true;
      let image_identifier = sku.sku_face + '_' + sku.category;
      try {
        if (!this.review_screen_sku_images[image_identifier]) {
          const response = await this.apiService
            .fetchImageFromBlob(sku.sku_image_uri)
            .toPromise();
          const imageUrl = URL.createObjectURL(response);
          sku.blob_img_uri = imageUrl;
          if(imageUrl){
            this.planogramState.setImagesToReviewList(image_identifier,imageUrl)
          }
        } else {
          sku.blob_img_uri = this.review_screen_sku_images[image_identifier];
        }
      } catch (error) {
        console.error(
          `Error fetching image for SKU: ${sku.sku_image_uri}`,
          error
        );
      } finally {
        sku.loading = false;
      }
    }
    return dataArray;
  }

  filterSkuBasedOnSearch(event: any) {
    this.sku_search_input = event.target.value;
    if (this.sku_search_input.length > 0) {
      this.search_filtered_sku_list = this.search_filtered_sku_list.filter(
        (sku: any) =>
          sku.sku_face
            .toLowerCase()
            .includes(this.sku_search_input.toLowerCase())
      );
      // this.search_filtered_sku_list = this.getImages(
      //   this.search_filtered_sku_list
      // );
      if (this.search_filtered_sku_list.length == 0) {
        this.search_message = 'No results found';
      } else {
        this.search_message = '';
      }
    } else {
      this.search_filtered_sku_list = this.filter_sku_list;
      // this.search_filtered_sku_list = this.getImages(
      //   this.search_filtered_sku_list
      // );
    }
  }

  changeLabel(val: string): void {
    this.selectedLabel = val;
  }
}
